































import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import {
  both, includes, filter, sortBy, sortWith, prop, descend, ascend, clone, find,
} from 'ramda'
import dayjs from 'dayjs'
// import { vueVimeoPlayer } from 'vue-vimeo-player'
import {
  getModule,
} from 'vuex-module-decorators'
import { db } from '../firebase/init'
import { DisplaySlideType, DisplayBoardType, SlideDetailsType } from '../types'
import MainMixin from '../mixins/MainMixin'
import EventBus from '../event-bus'
// Filter Functions

@Component({
  components: {
    // vueVimeoPlayer,
  },
})

export default class Display extends Mixins(MainMixin) {
  board:DisplayBoardType = {
    name: '',
    description: '',
    landscape: false,
    slides: [],
    created: new Date(),
    text: [],
    settings: {},
    location: '',
    startHour: 0,
  }

  get rotateStyle() {
    const rotate = this.$route.params.boardId === 'harts-garage-portrait'
    const d = {
      slideWrapperRotate: rotate,
      slideWrapper: !rotate,
    };
    return d
  }

  get slides() {
    if (!this.board || !this.board.slides) return []
    const filteredSlides:any = []
    this.board.slides.forEach((id:string) => {
      const slide:DisplaySlideType|undefined = this.allSlides.find((s:DisplaySlideType) => s.id === id)
      if (slide && slide.active) {
        const details = this.slideDetails.find((d:SlideDetailsType) => d.slide === id)
        // eslint-disable-next-line
        const isActiveResult = details ? this.isActive(details) : 'Cant find details'
        if (details && this.testActiveDate(details) && this.isActive(details)) {
          if (details) {
            const data = {
              id: slide.id,
              background: 'black', // slide.background,
              transition: slide.transition,
              type: slide.type,
              duration: details.duration,
              schedule: details.schedule,
              url: slide.url || '',
            }
            filteredSlides.push(data)
          }
        }
      }
    })
    return filteredSlides
  }

  testActiveDate(details:any) {
    if (!details) return false
    if (!details.startDate && !details.endDate) {
      return true
    }
    const validStart = !details.startDate || (details.startDate as any) <= this.viewDay.date
    const validEnd = !details.endDate || (details.endDate as any) >= this.viewDay.date
    if (validStart && validEnd) return true
    return false
  }

  isUpdated = false

  wrapperKey = 0

  windowHeight = window.innerHeight

  windowWidth = window.innerWidth

  // startSlide() {
  //   this.showPrevious = true
  //   this.nextSlide()
  //   setTimeout(() => {
  //     this.showPrevious = false
  //   }, 2500)
  //   const d = this.slides[this.slideIndex] ? this.slides[this.slideIndex].duration : 2000
  //   setTimeout(() => {
  //     this.startSlide()
  //   }, d)
  // }

  $refs:any

  // playVideo() {
  //   this.$refs.videoPlayer.play()
  // }

  animations = {
    slide: {
      translateX: ['100%', '0%'], duration: 1000, loop: false, easing: 'easeInOutSine',
    },
    bounce: {
      translateY: ['-100%', '0%'], duration: 2000, loop: false, easing: 'easeOutElastic(1, .5)',
    },
    rotate: { rotate: '1turn', duration: 2000 },
    zoom: { scale: [2, 1], opacity: ['50%', '100%'], duration: 2000 },
    fade: { },
  }

  slideIndex = 0

  // nextSlide() {
  //   console.log('asdfasdfasdf', this.slides.length)
  //   const lastSlide = this.slideIndex === this.slides.length - 1
  //   if (lastSlide) console.log('found last slide at ', this.slideIndex)
  //   // console.log('slideindex:', this.slideIndex, 'and length: ', this.slides.length, 'slides: ', this.slides)
  //   const newIndex = lastSlide ? 0 : this.slideIndex + 1
  //   console.log('here newIndex is: ', newIndex)
  //   if (this.slides && this.slides[newIndex] && this.slides[newIndex].id) {
  //     // console.log('Slide Exists!')
  //     this.slideIndex = newIndex
  //   } else {
  //     console.log('Slide did not exist at ', newIndex)
  //     this.slideIndex = 0
  //   }
  //   // console.log('newIndex: ', newIndex)
  //   // console.log('slideIndex: ', this.slideIndex)
  //   // console.log('Showing Slide ', this.slides[this.slideIndex] ? this.slides[this.slideIndex].id : 'error', 'with index: ', this.slideIndex, ' at ', new Date())
  // }

  get viewDay() {
    const d = dayjs()
    const day = d.day()
    const hour = d.hour()
    const date = d.format('YYYY-MM-DD')
    return { day, hour, date }
  }

  get activeSlide() {
    if (this.slides && this.slides.length > 0 && this.slides[this.slideIndex]) {
      return this.slides[this.slideIndex]
    } if (this.slides && this.slides.length > 0 && !this.slides[this.slideIndex]) {
      return this.slides[0]
    } return ''
  }

  get previousSlide() {
    if (this.slides && this.slides.length > 0 && this.slides[this.slideIndex]) {
      return this.slideIndex === 0 ? this.slides[this.slides.length - 1] : this.slides[this.slideIndex - 1]
    } if (this.slides && this.slides.length > 0 && !this.slides[this.slideIndex]) {
      return this.slides[0]
    } return ''
  }

  showPrevious = false

  get group() {
    return this.$route.params.group || 'group-not-found'
  }

  get boardId() {
    return this.$route.params.boardId || 'board-not-found'
  }

  isActive(slide:SlideDetailsType) {
    // console.log('Here now in isActive!!')
    const viewPreviousDay = this.board.startHour > this.viewDay.hour
    // eslint-disable-next-line no-nested-ternary
    const viewDate = viewPreviousDay ? (this.viewDay.day === 0 ? 6 : this.viewDay.day - 1) : this.viewDay.day
    // console.log('viewDats is: ', viewDate)
    const startHour = viewPreviousDay ? slide.schedule[viewDate].start % 24 : slide.schedule[viewDate].start
    // console.log('startHour: ', startHour)
    const endHour = viewPreviousDay ? slide.schedule[viewDate].end % 24 : slide.schedule[viewDate].end
    // console.log('end hour: ', endHour)
    if (startHour > this.viewDay.hour || endHour <= this.viewDay.hour) {
      // console.log('id: ', slide.id, ' failed here')
      return false
    }
    return true
  }

  imageUrl(id:string) {
    return `https://firebasestorage.googleapis.com/v0/b/canvas-displays/o/${this.group}%2Fslides%2F${id}_1920x1920.png?alt=media`
  }

  allSlides:DisplaySlideType[] = []

  slideDetails:SlideDetailsType[] = []

  runIndex() {
    // console.log('running test at index: ', this.slideIndex)
    if (this.slides.length > 0 && this.slides[this.slideIndex]) {
      const index = clone(this.slideIndex)
      setTimeout(() => {
        this.slideIndex = this.slideIndex === this.slides.length - 1 ? 0 : this.slideIndex + 1
        this.runIndex()
      }, this.slides[index].duration || 4000)
    } else {
      setTimeout(() => {
        this.slideIndex = 0
        this.runIndex()
      }, 3000)
    }
  }

  async created() {
    const result = await Promise.all([
      this.$bind('board', db.collection('displayBoards').doc(this.boardId), { maxRefDepth: 0 }),
      this.$bind('allSlides', db.collection('displaySlides').where('boards', 'array-contains', this.boardId), { maxRefDepth: 0 }),
      this.$bind('slideDetails', db.collection('displaySlideDetails').where('board', '==', this.boardId), { maxRefDepth: 0 }),
    ])
    // console.log('Display Result is:', result)
    setTimeout(() => {
      this.runIndex()
    }, 100)
  }
}
